<template>
  <div>
    <heading class="mb-1 font-semibold" :level="1">{{ $t('Plan type') }}</heading>
    <p class="mb-6">{{ product.name }}</p>
    <heading class="mb-1 font-semibold" :level="1">{{ $t('Billing frequency') }}</heading>
    <select-control
      v-model="interval"
      :dusk="'plan-select'"
      class="block mb-6 w-full"
      :options="frequencies"
      :selected="interval"
      value-key="interval"
      label="nickname"
    />
    <UserCountField
      v-model="usersCount"
      :current-count="currentUserCount"
      :price="pricePerUser"
      :currency="selectedPlan.currency"
      :interval="selectedPlan.interval"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import UserCountField from '@/_legacy/components/Subscriptions/UserCountField.vue';
  import authMixin from '@/_legacy/mixins/authMixin';
  import subscriptionMixin from '@/_legacy/mixins/subscriptionMixin';
  import { SUBSCRIPTION_INTERVALS } from '@/_legacy/constants';

  export default {
    name: 'PlanDetails',

    components: { UserCountField },

    mixins: [authMixin, subscriptionMixin],

    computed: {
      ...mapGetters({
        nextProduct: 'subscription/nextProduct',
        product: 'subscription/product',
        selectedPlan: 'subscription/selectedPlan',
      }),

      subscription() {
        return this.loggedInUser() && this.loggedInUser()._legacy_subscription;
      },

      interval: {
        get() {
          return this.selectedPlan.interval;
        },
        set(value) {
          let product = this.product;
          if (this.nextProduct !== this.product && this.isIntervalSwitchAllowedToKeepCurrentProduct(product.interval, value)) {
            product = this.nextProduct;
            this.$store.commit('subscription/setProduct', this.nextProduct);
          }
          const selected = product.plans.length && product.plans.find(
            plan => plan.interval === value,
          );
          this.$store.commit('subscription/setSelectedPlan', selected);
        },
      },

      pricePerUser() {
        let price = 0;
        if (this.selectedPlan.tiers && this.selectedPlan.tiers.length) {
          const selectedTier = this.selectedPlan.tiers.find(
            tier => this.usersCount <= parseInt(tier.up_to, 10) || !tier.up_to,
          );

          price = selectedTier ? selectedTier.unit_amount : 0;

          return parseInt(price, 10);
        }

        if (this.selectedPlan) {
          price = parseFloat(this.selectedPlan.amount);
        }

        return parseInt(price, 10);
      },

      total() {
        return this.pricePerUser * this.usersCount;
      },

      frequencies() {
        if (!this.product.plans) {
          return [];
        }

        if (this.nextProduct) {
          return this.nextProduct.plans.map(({ interval, nickname }) => ({
            label: this.formatFrequency(interval, nickname),
            value: interval,
          }));
        }

        return this.product.plans.map(({ interval, nickname }) => ({
          label: this.formatFrequency(interval, nickname),
          value: interval,
        }));
      },
    },

    watch: {
      total() {
        this.$emit('total-updated', this.total);
      },
      usersCount() {
        this.$emit('count-updated', this.usersCount);
      },
    },

    mounted() {
      this.usersCount = this.initialUsersCount();
    },

    methods: {
      isIntervalSwitchAllowedToKeepCurrentProduct(oldInterval, newInterval) {
        return oldInterval !== newInterval && newInterval !== SUBSCRIPTION_INTERVALS.YEARLY;
      },
      initialUsersCount() {
        const usersQuery = this.$route.query.users;
        if (usersQuery) {
          return parseInt(usersQuery, 10);
        }

        if (!this.subscription) {
          return 1;
        }

        if (this.subscription.users && this.subscription.users.count && this.subscription.quantity) {
          const usersCount = this.subscription.users.count;
          const subscriptionQuantity = this.subscription.quantity;
          return usersCount > subscriptionQuantity ? usersCount : subscriptionQuantity;
        }

        return 1;
      },
      formatFrequency(frequency, fallback) {
        return {
          day: this.$t('Daily'),
          month: this.$t('Monthly'),
          year: this.$t('Yearly'),
        }[frequency] || fallback;
      },
    },
  };
</script>
